import React from 'react';
import { func, number, string } from 'prop-types';
import styled, { css } from 'styled-components';
import {
  Button, Flex, Typography, Icon,
} from '@atoms';
import { ReactComponent as RemoveItemIcon } from '@assets/remove-item.svg';

const OrdoItem = ({
  name,
  onItemClick,
  onItemRemove,
  id,
}) => (
  <Wrapper>
    <Container
      onClick={onItemClick(id)}
      wrapFlex
      justifyCenter
      padding="md"
      data-cy="ordo-item"
    >
      <Typography color="strawberry">
        {name}
      </Typography>
    </Container>
    {onItemRemove
      ? (
        <RemoveItemIconContainer justifyCenter itemsCenter grow={0} onClick={onItemRemove(id)}>
          <Icon SVG={RemoveItemIcon} width="15px" height="15px" />
        </RemoveItemIconContainer>
      )
      : null}
  </Wrapper>
);

const Wrapper = styled(Flex)`
  position: relative;
`;

const Container = styled(Flex)`
  ${({
    theme: {
      color, spacing, typography, boxShadow,
    },
  }) => css`
    user-select: none;
    width: 100%;
    background-color: ${color.white};
    border-radius: 23px;
    margin-bottom: ${spacing.md};
    box-shadow: ${boxShadow.default};

    ${Button.Circular} {
      position: absolute;
      top: -5px;
      left: -5px;
    }

    ${Typography} {
      font-size: ${typography.size.md};
      font-weight: ${typography.weight.bold};
    }
  `}
`;

const RemoveItemIconContainer = styled(Flex)`
  ${({ theme: { border, color } }) => css`
    position: absolute;
    right: -35px;
    top: 6px;
    width: 23px;
    height: 23px;
    border-radius: ${border.radius.circular};
    background-color: ${color.strawberry};
  `}}
`;

OrdoItem.defaultProps = {
  onItemClick: () => {},
  onItemRemove: null,
};

OrdoItem.propTypes = {
  id: number.isRequired,
  onItemClick: func,
  onItemRemove: func,
  name: string.isRequired,
};

export default OrdoItem;
